export default "__VITE_ASSET__BDxMziVr__"